"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.typography = exports.letterSpacing = exports.lineHeight = exports.fontWeight = exports.fontSize = void 0;
var _sizing = require("./sizing");
var _colors = _interopRequireWildcard(require("./colors"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var fontSize = {
  xxxs: '12px',
  xxs: '14px',
  xs: '16px',
  sm: '18px',
  md: '20px',
  lg: '24px',
  xl: '32px',
  xxl: '36px',
  xxxl: '48px',
  xxxxl: '60px'
};
exports.fontSize = fontSize;
var fontWeight = {
  light: 200,
  regular: 300,
  semiBold: 400,
  bold: 500,
  extraBold: 600
};
exports.fontWeight = fontWeight;
var lineHeight = {
  sm: 0.75,
  md: 1.3,
  lg: 1.6,
  xl: 2
};
exports.lineHeight = lineHeight;
var letterSpacing = {
  default: 0
};
exports.letterSpacing = letterSpacing;
var typography = {
  h1: {
    color: _colors.default.text00,
    colorInverse: _colors.default.text03,
    fontSizeSm: fontSize.lg,
    fontSizeMd: fontSize.xl,
    fontSizeLg: fontSize.xxxl,
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.md,
    marginBottom: _sizing.space.lg,
    marginTop: 0,
    marginBottomLg: _sizing.space.lg,
    marginTopLg: 0
  },
  h2: {
    color: _colors.default.text01,
    colorInverse: _colors.default.text03,
    fontSizeSm: fontSize.lg,
    fontSizeMd: fontSize.xl,
    fontSizeLg: fontSize.xl,
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.md,
    marginBottom: _sizing.space.sm,
    marginTop: 0,
    marginBottomLg: _sizing.space.sm,
    marginTopLg: 0
  },
  h3: {
    color: _colors.default.text01,
    colorInverse: _colors.default.text03,
    fontSizeSm: fontSize.sm,
    fontSizeLg: fontSize.md,
    fontWeight: fontWeight.semiBold,
    lineHeight: lineHeight.md,
    marginBottom: _sizing.space.md,
    marginTop: 0,
    marginBottomLg: _sizing.space.md,
    marginTopLg: 0
  },
  h4: {
    color: _colors.default.text01,
    colorInverse: _colors.default.text03,
    fontSizeSm: fontSize.sm,
    fontSizeLg: fontSize.sm,
    fontWeight: fontWeight.semiBold,
    lineHeight: lineHeight.md,
    marginBottom: _sizing.space.md,
    marginTop: 0,
    marginBottomLg: _sizing.space.md,
    marginTopLg: 0
  },
  h5: {
    color: _colors.default.text00,
    colorInverse: _colors.default.text03,
    fontSizeSm: fontSize.xxs,
    fontSizeLg: fontSize.xs,
    fontWeight: fontWeight.semiBold,
    lineHeight: lineHeight.lg,
    marginBottom: _sizing.space.sm,
    marginTop: 0,
    marginBottomLg: _sizing.space.sm,
    marginTopLg: 0
  },
  p: {
    color: _colors.default.text01,
    colorInverse: _colors.default.text03,
    fontSizeXs: fontSize.xxxs,
    fontSizeSm: fontSize.xxs,
    fontSizeMd: fontSize.xs,
    fontSizeLg: fontSize.sm,
    fontSizeXl: fontSize.md,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.lg,
    marginBottom: _sizing.space.lg,
    marginTop: 0,
    marginBottomLg: _sizing.space.lg,
    marginTopLg: 0
  },
  li: {
    color: _colors.default.text01,
    colorInverse: _colors.default.text03,
    fontSizeSm: fontSize.xxs,
    fontSizeMd: fontSize.xs,
    fontSizeLg: fontSize.sm,
    fontSizeXl: fontSize.lg,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.lg,
    marginBottom: _sizing.space.xs,
    marginTop: 0,
    marginBottomLg: _sizing.space.xs,
    marginTopLg: 0,
    padding: "".concat(_sizing.space.xxs, " 0 ").concat(_sizing.space.sm, " 0"),
    bulletColor: _colors.default.brandPrimary,
    bulletColorInverse: _colors.default.ui00,
    bulletSize: '5px',
    bulletTop: '5px',
    bulletLeft: _sizing.space.lg
  },
  blockquote: {
    color: _colors.default.text01,
    colorInverse: _colors.default.text03,
    fontSizeLg: fontSize.lg,
    fontSizeSm: fontSize.lg,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.md,
    marginBottom: _sizing.space.xxl,
    marginTop: 0,
    marginBottomLg: _sizing.space.xxl,
    marginTopLg: 0,
    quoteColor: _colors.default.brandSecondary,
    quoteColorInverse: _colors.default.ui00,
    quoteSize: fontSize.xxxxl
  },
  link: {
    underlineColor: _colors.default.brandSecondaryInteract,
    underlineColorActive: _colors.default.brandSecondary,
    colorHover: _colors.default.brandSecondary,
    underlineTextColor: _colors.default.text01,
    colorVisited: _colors.default.textLinkVisited,
    underlineColorInverseActive: _colors.palette.gray40
  }
};
exports.typography = typography;
var _default = {
  fontSize: fontSize,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  typography: typography,
  letterSpacing: letterSpacing
};
exports.default = _default;